export const ItemTypes = {
  rack: 'RACK',
  packageItem: 'PackageItem',
  aisle: 'AISLE',
};
